module.exports = __webpack_public_path__ + "static/PatKT-05-cc71a966f1896908ab7b888fcb5058e3.jpg";